module.exports = __webpack_public_path__ + "static/media/btd.ffa50321.png";